import { Mapping } from 'src/containers/ProjectDiagram/types/data';
import {
  prevProjectMappingSelector,
  projectMappingSelector,
} from 'src/selectors/projectMapping';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useMappingFromRoute = (): Mapping | null => {
  const { mappingId, projectId } = useRouterParams<'PROJECT_MAPPING'>();

  return useReduxSelector(projectMappingSelector(projectId, mappingId));
};

export const usePrevMappingFromRoute = (): Mapping | null => {
  const { mappingId, projectId } = useRouterParams<'PROJECT_MAPPING'>();

  return useReduxSelector(prevProjectMappingSelector(projectId, mappingId));
};
